//Routes
import routing from './pharmacist.routes';

//Controllers
import PharmacistController from './controllers/pharmacist.controller';
import DetailsController from './controllers/details.controller';
import BillingController from './controllers/billing.controller';
import TransactionController from './controllers/transaction.controller';
import TrainingController from './controllers/training.controller';
import DocumentationController from './controllers/documentation.controller';

//Services
import PharmacistService from 'services/pharmacist.service';
import TransactionService from 'services/transaction.service';
import TrainingService from 'services/training.service';
import MessageService from 'services/message.service';

//Add to Angular
export default angular.module('hmrx.app.pharmacist', [PharmacistService, TransactionService, TrainingService, MessageService])
  .config(routing)
  //Add all controllers
  .controller('PharmacistController', PharmacistController)
  .controller('DetailsController', DetailsController)
  .controller('BillingController', BillingController)
  .controller('TransactionController', TransactionController)
  .controller('TrainingController', TrainingController)
  .controller('DocumentationController', DocumentationController)
  .name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/features/pharmacist/index.js
 **/